(function () {
  'use strict';

  var CART_GET_FULFILLED = 'cart/getCart/fulfilled';
  var fastSyncRunId = 0;
  var fetchPatched = false;
  var ADD_BUTTON_SELECTOR = [
    'button[name="add"]',
    '[data-add-to-cart]',
    '.product-form__submit',
    '[data-complemented-product-add-button]',
    '.fg-add-btn'
  ].join(', ');

  function getDrawer() {
    return document.querySelector('#cart-drawer') || document.querySelector('#CartDrawer');
  }

  function isDrawerOpen(drawer) {
    return !!(drawer && drawer.hasAttribute('open'));
  }

  function canFastOpenFromButton(button) {
    if (!button || button.disabled) return false;
    if (button.getAttribute('data-skip-fast-open') === 'true') return false;
    if (button.getAttribute('aria-disabled') === 'true') return false;

    var form = button.closest('form');
    if (!form) return false;

    var looksLikeAddButton = button.matches(ADD_BUTTON_SELECTOR);
    var action = (form.getAttribute('action') || '').toLowerCase();
    var hasCartAddAction = action.indexOf('/cart/add') !== -1;
    var hasVariantInput = !!form.querySelector('input[name="id"], input[name="items[0][id]"]');

    if (!hasCartAddAction && !looksLikeAddButton && !hasVariantInput) return false;

    if (typeof form.checkValidity === 'function' && !form.checkValidity()) return false;
    return true;
  }

  function canFastOpenFromForm(form) {
    if (!form || form.tagName !== 'FORM') return false;

    var action = (form.getAttribute('action') || '').toLowerCase();
    var hasCartAddAction = action.indexOf('/cart/add') !== -1;
    var hasAddTrigger = !!form.querySelector(ADD_BUTTON_SELECTOR);
    var hasVariantInput = !!form.querySelector('input[name="id"], input[name="items[0][id]"]');

    if (!hasCartAddAction && !hasAddTrigger && !hasVariantInput) return false;
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) return false;
    return true;
  }

  function openDrawerSoon() {
    var drawer = getDrawer();
    if (!drawer || isDrawerOpen(drawer)) return;

    // Let validation/UI state settle first, then open optimistically.
    requestAnimationFrame(function () {
      if (!window._cartFastOpenDispatched) {
        window._cartFastOpenDispatched = true;
        window.dispatchEvent(new CustomEvent('productAddedOpenDrawer'));
        // Reset flag after event completes
        setTimeout(function () { window._cartFastOpenDispatched = false; }, 100);
      }
    });
  }

  function getStoreSnapshot() {
    var state = window.Store && typeof window.Store.getState === 'function'
      ? window.Store.getState()
      : null;
    var cart = state && state.cart ? state.cart : null;
    return {
      itemCount: cart && typeof cart.item_count === 'number' ? cart.item_count : null
    };
  }

  function parseFormQuantity(form) {
    if (!form) return 1;
    var qtyInput = form.querySelector('input[name="quantity"], input[name="qty"], [name="quantity"]');
    if (!qtyInput) return 1;

    var value = parseInt(qtyInput.value, 10);
    if (isNaN(value) || value < 1) return 1;
    return value;
  }

  function dispatchCartToStore(cart) {
    if (!window.Store || typeof window.Store.dispatch !== 'function') return;
    window.Store.dispatch({
      type: CART_GET_FULFILLED,
      payload: cart
    });
  }

  function cloneObject(value) {
    if (!value || typeof value !== 'object') return value;
    try {
      return JSON.parse(JSON.stringify(value));
    } catch (e) {
      return value;
    }
  }

  function readStoreCartState() {
    if (!window.Store || typeof window.Store.getState !== 'function') return null;
    var state = window.Store.getState();
    return state && state.cart ? state.cart : null;
  }

  function extractAddedItems(payload) {
    if (!payload || typeof payload !== 'object') return [];
    if (Array.isArray(payload.items)) return payload.items;
    if (typeof payload.id === 'number' || typeof payload.variant_id === 'number') return [payload];
    return [];
  }

  function itemKeyForMerge(item) {
    if (!item || typeof item !== 'object') return '';
    if (item.key) return String(item.key);

    var variantId = item.variant_id || item.id || '';
    var sellingPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
      ? item.selling_plan_allocation.selling_plan.id
      : (item.selling_plan || '');
    var props = item.properties && typeof item.properties === 'object'
      ? JSON.stringify(item.properties)
      : '';
    return [variantId, sellingPlan, props].join('::');
  }

  function optimisticApplyAddedItems(addedItems) {
    if (!addedItems || !addedItems.length) return;

    var cartState = readStoreCartState();
    if (!cartState) return;

    var optimisticCart = cloneObject(cartState.cart || {}) || {};
    var baseItems = Array.isArray(optimisticCart.items)
      ? optimisticCart.items
      : (Array.isArray(cartState.items) ? cloneObject(cartState.items) : []);

    addedItems.forEach(function (added) {
      if (!added || typeof added !== 'object') return;

      var addedQty = Number(added.quantity || 1);
      var mergeKey = itemKeyForMerge(added);
      var idx = -1;

      for (var i = 0; i < baseItems.length; i += 1) {
        if (itemKeyForMerge(baseItems[i]) === mergeKey) {
          idx = i;
          break;
        }
      }

      if (idx >= 0) {
        var existing = baseItems[idx] || {};
        var existingQty = Number(existing.quantity || 0);
        existing.quantity = existingQty + (isNaN(addedQty) ? 1 : addedQty);

        var unitPrice = Number(added.final_price || added.price || existing.final_price || existing.price || 0);
        if (!isNaN(unitPrice) && unitPrice > 0) {
          existing.final_line_price = unitPrice * existing.quantity;
          if (typeof existing.price === 'undefined' && typeof added.price !== 'undefined') {
            existing.price = added.price;
          }
          if (typeof existing.final_price === 'undefined' && typeof added.final_price !== 'undefined') {
            existing.final_price = added.final_price;
          }
        }

        baseItems[idx] = existing;
      } else {
        baseItems.push(cloneObject(added));
      }
    });

    optimisticCart.items = baseItems;
    optimisticCart.item_count = baseItems.reduce(function (sum, item) {
      var qty = Number(item && item.quantity ? item.quantity : 0);
      return sum + (isNaN(qty) ? 0 : qty);
    }, 0);

    dispatchCartToStore(optimisticCart);
  }

  function runCartSyncAttempt(runId, baselineCount, expectedCount, isFinalAttempt) {
    if (runId !== fastSyncRunId) return;

    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (runId !== fastSyncRunId) return;

        var currentCount = typeof cart.item_count === 'number' ? cart.item_count : null;
        var countIncreased = currentCount !== null && baselineCount !== null && currentCount > baselineCount;
        var reachedExpected = currentCount !== null && expectedCount !== null && currentCount >= expectedCount;

        if (countIncreased || reachedExpected || isFinalAttempt) {
          dispatchCartToStore(cart);
        }
      })
      .catch(function () {
        // Silent fallback: native flow still updates cart eventually.
      });
  }

  function scheduleFastCartSync(form) {
    if (form) {
      var now = Date.now();
      var lastQueuedAt = Number(form.getAttribute('data-fast-cart-sync-at') || 0);
      if ((now - lastQueuedAt) < 250) return;
      form.setAttribute('data-fast-cart-sync-at', String(now));
    }

    var snapshot = getStoreSnapshot();
    var quantity = form ? parseFormQuantity(form) : 1;
    var expectedCount = snapshot.itemCount !== null ? snapshot.itemCount + quantity : null;
    var runId = ++fastSyncRunId;
    var attempts = [80, 200, 450, 800, 1300, 1900, 2600, 3400];

    attempts.forEach(function (delay, index) {
      setTimeout(function () {
        runCartSyncAttempt(runId, snapshot.itemCount, expectedCount, index === attempts.length - 1);
      }, delay);
    });
  }

  function isCartAddRequest(resource) {
    var url = typeof resource === 'string'
      ? resource
      : (resource && typeof resource.url === 'string' ? resource.url : '');
    if (!url) return false;

    try {
      var normalized = new URL(url, window.location.origin);
      return normalized.pathname.indexOf('/cart/add') !== -1;
    } catch (e) {
      return url.indexOf('/cart/add') !== -1;
    }
  }

  function initAddSuccessSyncBridge() {
    if (fetchPatched || typeof window.fetch !== 'function') return;
    fetchPatched = true;

    var originalFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var requestLike = args[0];
      var addRequest = isCartAddRequest(requestLike);

      return originalFetch.apply(this, args).then(function (response) {
        if (addRequest && response && response.ok) {
          try {
            response.clone().json().then(function (payload) {
              optimisticApplyAddedItems(extractAddedItems(payload));
            }).catch(function () {
              // Ignore parse failures; reconciliation sync still runs below.
            });
          } catch (e) {
            // Ignore clone/json failures and rely on cart.js reconciliation.
          }

          // As soon as add.js succeeds, force a fresh cart sync for drawer items.
          scheduleFastCartSync(null);
        }
        return response;
      });
    };
  }

  function init() {
    initAddSuccessSyncBridge();

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      var addButton = target.closest(ADD_BUTTON_SELECTOR);
      if (!addButton || !canFastOpenFromButton(addButton)) return;

      openDrawerSoon();
      scheduleFastCartSync(addButton.closest('form'));
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!canFastOpenFromForm(form)) return;

      openDrawerSoon();
      scheduleFastCartSync(form);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
